import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';

import { parseQueryString } from '../../helpers';
import { SPLIT_KEY_FETCHED } from '../../actions/auth/getCustomer';

import TakeCarePanel from '../../components/landing/takeCarePanel';
import BreachBenefitsPanel from '../../components/landing/breachBenefitsPanel';
import { Container } from '../../components';

import ECD2PageInit from '../../components/ECD2PageInit';

const BackgroundContainer = styled.section`
  position: relative;
  z-index: 5;
  background: ${({ theme }) => theme.colors.baseLightGrey};
`;

const BenefitsContainer = styled(Container)`
  position: relative;
  z-index: 10;
`;

const LandingBackground = styled(Container)`
  background-color: ${({ theme }) => theme.colors.experianLighterGrey};
  max-width: 100%;
  width: 100%;
  padding: 0;

  ${({ theme: { media } }) =>
    media(
      '15',
      `
    padding: 0;
  `
    )}

  ${({ theme: { media } }) =>
    media(
      '30',
      `
    max-width: 100%;
  `
    )}
`;

const LandingPage = ({ location = {} }) => {
  const { voucher } = parseQueryString(location.search);
  const dispatch = useDispatch();

  dispatch({
    type: SPLIT_KEY_FETCHED,
    payload: 'anonymous',
  });

  return (
    <LandingBackground>
      <ECD2PageInit pageName="IdentityGetStartedProtectionPage" />
      <BackgroundContainer>
        <TakeCarePanel voucher={voucher || ''} />
      </BackgroundContainer>
      <BenefitsContainer>
        <BreachBenefitsPanel />
      </BenefitsContainer>
    </LandingBackground>
  );
};

LandingPage.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string,
  }).isRequired,
};

export default LandingPage;
